<template>
  <div>
    <b-form-group :label-for="comData.title" v-if="!comData.is_lang">
      <div v-if="comData.type == 'blocks'">
        <blockRepeater
          v-if="comData.blocks"
          :dataKey="dataKey"
          :dataIndex="dataIndex"
          :comData="comData"
          @update-block-data="UpdateBlockData"
          @delete-block="RemoveBlock"
          @popupBlocks="popupBlocks"
          @ordering-block="orderingBlock"
        />
        <b-button   v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-success" 
          @click="popupBlocks()"
        >
          Add Blocks
        </b-button>
      </div>
      <div v-if="comData.type == 'table'">
        <tableRepeater
          v-if="comData.tables"
          :dataKey="dataKey"
          :dataIndex="dataIndex"
          :comData="comData"
          @ordering-table="orderingTable"
          @update-table-data="UpdateTableData"
          @delete-table="RemoveTable"
        
        />
        <b-button   v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-success" 
          @click="popupTable()"
        >
          Add Table
        </b-button>

      </div>
      <div :label="`${comData.title}`" v-if="comData.type == 'text'">
        {{ comData.title }}
        <b-form-input
          v-if="comData.type == 'text'"
          v-model="comData.value"
          autofocus
          @input="ChangeData(comData)"
          trim
          :placeholder="`${comData.title}`"
        />
      </div>
      <b-form-input
        v-if="comData.type == 'Integer'"
        v-model="comData.value"
        autofocus
        @input="ChangeData(comData)"
        trim
      />
      <b-form-textarea
        v-if="comData.type == 'textarea'"
        v-model="comData.value"
        autofocus
        @input="ChangeData(comData)"
        trim
      />
      <v-select
        v-if="comData.type == 'banner'"         
        class="d-block"
        v-model="comData.value"
        placeholder="Select Banner"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="title"
        @input="ChangeData(comData)"
        :reduce="(option) => option.id"
        :options="dataBanners"   
      />
      <v-select
        v-if="comData.type == 'comments'"         
        class="d-block"
        v-model="comData.value"
        placeholder="Select Comments"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="title"
        @input="ChangeData(comData)"
        :reduce="(option) => option.id"
        :options="commentData"   
      />
      <quill-editor  v-if="comData.type == 'editor'" :options="editorOptions" v-model="comData.value" @input="ChangeData(comData)" />
      <div v-if="comData.type == 'images'">
        <b-row v-if="comData.files">
          <b-col md="2" v-for="(file,i) in comData.files" :key="'file-'+i" class="div-images">
            <a class="" @click="Removeconfirm(i)">
              <feather-icon icon="XCircleIcon" size="24"  class="text-danger" />
            </a>
            <b-img  class="w-100 cover-image"   :src="file" />
          </b-col>
        </b-row>
        <div class="mt-1">
          <b-button   
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-success" @click="popupFiles(comData)"
          >
            Selected Image
          </b-button>
        </div>
      </div>
    </b-form-group>
    <b-form-group  :label="comData.title" :label-for="comData.title" v-else>
      <b-tabs>
        <b-tab v-for="(lang,key) in langs" :key="'tab-'+comData.title+'-'+key"  :title="lang.name">
          <b-form-input
            v-if="comData.type == 'text'"
            v-model="comData.value_lang[lang.code]"
            autofocus
            @input="ChangeData(comData)"
            trim
          />
          <b-form-textarea
            v-if="comData.type == 'textarea'"
            v-model="comData.value_lang[lang.code]"
            autofocus
            @input="ChangeData(comData)"
            trim
          />
          <quill-editor  v-if="comData.type == 'editor'" :options="editorOptions" v-model="comData.value_lang[lang.code]" @input="ChangeData(comData)" />
        </b-tab>
      </b-tabs>
    </b-form-group>
  </div>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import BCardCode from '@core/components/b-card-code'
import {
  BCard, BCardText, BFormFile, BForm, BFormGroup, BFormInput, BFormTextarea, BRow, BCol, BButton, BImg, BTabs, BTab
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ref,onUnmounted } from '@vue/composition-api'
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
//import { slugify } from '@/@fake-db/utils'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
import groupStoremodule from '@/views/components/groupStoremodule'
import store from '@/store'
import { integer } from 'vee-validate/dist/rules'
//import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import languagesStoreModule from '@/views/languages/languagesStoreModule'
import BlockRepeater from '../pages-form/BlockRepeater.vue'
import TableRepeater from './TableRepeater.vue'

export default {
    components: {
      BCard, BCardText, BFormFile, BCardCode, BForm, BRow, BCol, BButton, BFormGroup, BFormInput, BImg, BFormTextarea,
      BTabs, BTab, BlockRepeater, vSelect, quillEditor,TableRepeater
    },

    model: {
      prop: 'data',
    },

    props: {
      data: {
        type: Object,
        required: true,
      },
      dataIndex:{
        type: Number
      },
      dataBanners:{
        type: Array
      },
      dataKey:{
        type: Number,
      },
      PageInputRepeater: {
        type: Array
      },
      commentData: {
        type: Array
      }
    },

    directives: {
      Ripple,
    },

    computed: {
      editorOptions (){
        return $themeConfig.snowOption
      } 
    },

    setup(props, { emit }) {
      const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
      if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
      onUnmounted(() => {
          if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
      });
       
      if(!props.data.value_lang){
        props.data.value_lang = {}
      }

      const comData = ref(JSON.parse(JSON.stringify(props.data)));
      const langs = ref([]);

      const orderingBlock = (items) => {
        emit('ordering-blocks', items, props.dataKey, props.dataIndex)
      }
      const orderingTable = (items)=>{
        emit('ordering-tables', items, props.dataKey, props.dataIndex)

      }

      const ChangeData = (dat)=>{
        dat.key = props.dataKey;
        dat.index = props.dataIndex;

        emit('refetch-data',dat);
      }

      const removefiles = (index)=>{
        comData.value.files.splice(index, 1);
        let data =  comData.value;
        data.key = props.dataKey;
        data.index = props.dataIndex;
        
        emit('refetch-data',data);
      }
    
      const popupFiles = ()=>{
        const position = {
          dataIndex:props.dataIndex,
          dataKey:props.dataKey,
        }

        if(comData.value.files){
          position.files = comData.value.files
        }else{
          position.files = []
        }
      
        emit('open-files', position);
      }

      const UpdateBlockData = (index) => {
        let data =  comData.value;

        data.dataKey = props.dataKey;
        data.dataIndex = props.dataIndex;
        data.blockIndex = index

        emit('open-blocks', data);
      }
      const UpdateTableData=(index)=>{
          let data =  comData.value;
          console.log('UpdateTableData',data);

          data.dataKey = props.dataKey;
          data.dataIndex = props.dataIndex;
          data.tableIndex = index
        
          emit('open-table', data);

      }
      const popupTable = ()=>{


        const position = {
          dataIndex: props.dataIndex,
          dataKey: props.dataKey,
          
          
        }
        position.tables = []

        emit('open-table', position);

      }
      const popupBlocks = ()=>{
        const position = {
          dataIndex: props.dataIndex,
          dataKey: props.dataKey,
        }

        if(comData.value.blocks){
          position.blocks = comData.value.blocks;
        }else{
          position.blocks = []
        }

        emit('open-blocks', position);
      }

      const RemoveBlock = () => {
        let data =  comData.value;
        data.key = props.dataKey;
        data.index = props.dataIndex;

        emit('refetch-data', data);
      }
      const RemoveTable = () => {
        let data =  comData.value;
        data.key = props.dataKey;
        data.index = props.dataIndex;

        emit('refetch-data', data);
      }
      

      // const getLangs = (fil)=>{
      //   store.dispatch('app-languages/fetchData', fil)
      //     .then((res) => {
      //       if(res.data.success){
      //         langs.value = res.data.data;
              
      //       }     
      //     }
      //   );
      // }

      let filter = {
        is_active:1,
      }

      store.dispatch('app-languages/fetchData', filter)
        .then((res) => {
          if(res.data.success){
            langs.value = res.data.data;
            
          }     
        }
      );

      // getLangs(filter);
   
      return {
        comData,
        ChangeData,
        popupFiles,
        removefiles,
        langs,
        popupBlocks,
        popupTable,
        UpdateBlockData,
        RemoveBlock,
        orderingBlock,
        UpdateTableData,
        orderingTable,
        RemoveTable
      }
    },

  methods:{
    Removeconfirm(index){
      this.$bvModal
          .msgBoxConfirm('Please confirm that you want to Remove file?', {
            title: 'Please Confirm',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if(value === true){
              this.removefiles(index)
            }
          })
    },
  }
}
</script>
